var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCredendo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 245.03 56.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -268.48,
    y1: 378.37,
    x2: -265.79,
    y2: 373.93,
    gradientTransform: "rotate(-90 -198.85 -44.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#350f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#721f00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -266.15,
    y1: 360.25,
    x2: -257.87,
    y2: 360.25,
    gradientTransform: "rotate(-90 -198.85 -44.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48190c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#350f10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -299.69,
    y1: 365.25,
    x2: -294.18,
    y2: 359.8,
    gradientTransform: "rotate(-90 -198.85 -44.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#721f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350f10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -300.67,
    y1: 364.26,
    x2: -295.16,
    y2: 358.81,
    gradientTransform: "rotate(-90 -198.85 -44.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d2cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -274.42,
    y1: 381.78,
    x2: -266.15,
    y2: 381.78,
    gradientTransform: "rotate(-90 -198.85 -44.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6f2a0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200a0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -274.42,
    y1: 383.16,
    x2: -266.15,
    y2: 383.16,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -266.4,
    y1: 378.85,
    x2: -270.56,
    y2: 383.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -266.28,
    y1: 363.42,
    x2: -269.21,
    y2: 368.02,
    gradientTransform: "rotate(-90 -198.85 -44.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#48190c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#350f10"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#350f10}.cls-3{fill:#721f00}.cls-4{fill:#e84e0f}"))), /*#__PURE__*/React.createElement("path", {
    d: "M16.29 2.19V.81h8.28A1.38 1.38 0 0 1 26 2.19v1.37h-8.33a1.37 1.37 0 0 1-1.38-1.37Zm104.82 11h-8.28v1.41a1.38 1.38 0 0 0 1.38 1.4h8.28v-1.4a1.38 1.38 0 0 0-1.38-1.38Zm99.61 0h-8.27v1.41a1.38 1.38 0 0 0 1.38 1.4h8.27v-1.4a1.38 1.38 0 0 0-1.38-1.38ZM193.8 14.6a1.38 1.38 0 0 0-1.38-1.38h-8.27v1.38a1.37 1.37 0 0 0 1.37 1.4h8.28ZM166.93 27a1.37 1.37 0 0 0-1.37-1.38h-9.16l6.72-8.76-1.72-2.3-6.88 9v4.85h12.41Zm-7.58-24.81a1.37 1.37 0 0 0 1.38 1.37h9.11l-6.7 8.74 1.73 2.3 6.89-9V2.19a1.38 1.38 0 0 1 1.38-1.38h-13.79ZM9.43 29.77a1.38 1.38 0 0 0-1.38-1.38H2.54a1.38 1.38 0 0 0-1.38 1.38v1.38h6.89a1.38 1.38 0 0 0 1.38-1.38Zm6.48-13a1.39 1.39 0 0 0 1.11.55h2.75L11.91 6.88a1.38 1.38 0 1 0-2.2 1.65ZM229.69.81a1.38 1.38 0 0 0-1.38 1.38v4.13a13.79 13.79 0 0 1 0 16.55V27a1.38 1.38 0 0 0 1.38 1.38h1.38V.81Zm-31.75 24.82h-2.76a13.7 13.7 0 0 1-8.26 2.76h13.77V14.6a13.72 13.72 0 0 1-2.75 8.27Zm-2.76-22.06h2.76v2.75a13.75 13.75 0 0 1 2.75 8.28V.81H186.9a13.69 13.69 0 0 1 8.28 2.76ZM146.62.81v1.38a1.38 1.38 0 0 1-1.37 1.38h1.37a4.83 4.83 0 1 1 0 9.65h-1.38a1.38 1.38 0 0 1 1.38 1.38V16a7.53 7.53 0 0 0 5.14-2V2.82a7.53 7.53 0 0 0-5.14-2ZM128 28.39h1.38V14.6a13.66 13.66 0 0 1-2.76 8.27V27a1.38 1.38 0 0 0 1.38 1.39Zm0-27.58a1.38 1.38 0 0 0-1.38 1.38v4.13a13.69 13.69 0 0 1 2.76 8.28V.81ZM98.35 3.56h-8.27A11 11 0 0 1 101 13.22h.09a1.38 1.38 0 0 1 1.38 1.38V16H101a11 11 0 0 1-10.9 9.65h8.24a13.8 13.8 0 0 0 0-22.07ZM61.84 28.39a13.84 13.84 0 0 0 4.16-.63v-2.93a11 11 0 0 1-4.14.8h-1.39A1.38 1.38 0 0 1 61.84 27v1.38Zm13.32-10.23c.07-.26.14-.53.19-.8h-.87Zm-6.43 5.05v3.33A13.85 13.85 0 0 0 74 21.07l-2-2.3a11 11 0 0 1-3.27 4.44ZM66 4.37V1.44a13.84 13.84 0 0 0-4.16-.63v1.38a1.39 1.39 0 0 1-1.37 1.38h1.37a11 11 0 0 1 4.16.8Zm4.13-.8h-1.4V6a11 11 0 0 1 4.14 8.61h2.76a13.76 13.76 0 0 0-5.52-11.04ZM43.91.81h-1.38l-19 24.81a1.37 1.37 0 0 0 .25 1.93l1.1.84 17.67-23V27a1.38 1.38 0 0 0 1.38 1.38h1.38v-5.51a13.79 13.79 0 0 1 0-16.55V2.19a1.38 1.38 0 0 0-1.4-1.38Z",
    transform: "translate(-1.16 -.81)",
    style: {
      fill: "#eceae6"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137 14.6v-1.38h8.27a1.38 1.38 0 0 1 1.38 1.38V16h-8.27a1.38 1.38 0 0 1-1.38-1.4ZM56.32.81A13.79 13.79 0 0 0 42.53 14.6a1.38 1.38 0 1 0 2.76 0 11 11 0 0 1 11-11 1.38 1.38 0 1 0 0-2.76Zm11 2.76h8.27a1.38 1.38 0 1 0 0-2.76H66v1.38a1.38 1.38 0 0 0 1.36 1.38ZM90.08 27V2.19A1.38 1.38 0 0 0 88.7.81h-1.38v27.58h1.38A1.38 1.38 0 0 0 90.08 27Zm20 0V2.19A1.38 1.38 0 0 0 108.7.81h-1.38v27.58h1.38a1.38 1.38 0 0 0 1.38-1.39Zm24.13 0V2.19a1.38 1.38 0 0 0-1.38-1.38h-1.38v27.58h1.38a1.38 1.38 0 0 0 1.38-1.39ZM75.63 14.6a1.38 1.38 0 0 0 0 2.76 8.28 8.28 0 0 0 8.27-8.28 1.38 1.38 0 1 0-2.75 0 5.52 5.52 0 0 1-5.52 5.52Zm26.86 0a1.38 1.38 0 0 0-1.38-1.38h-8.27v1.38a1.37 1.37 0 0 0 1.37 1.4h8.28ZM180 .81h-1.38v27.58H180a1.38 1.38 0 0 0 1.39-1.39V2.19A1.38 1.38 0 0 0 180 .81Zm-25.49 0v4.6l17.24 23v-4.6l-17.23-23Z",
    transform: "translate(-1.16 -.81)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.62 27v1.38h-13.78a1.38 1.38 0 0 0 1.37-1.38v-1.37h11a1.38 1.38 0 0 1 1.41 1.37ZM75.63.81a1.38 1.38 0 1 1 0 2.76 5.52 5.52 0 0 1 5.52 5.51 1.38 1.38 0 1 1 2.75 0A8.27 8.27 0 0 0 75.63.81Zm111.27 0H180a1.38 1.38 0 0 1 1.38 1.38v1.38h5.51a11 11 0 1 1 0 22.06h-5.51V27a1.38 1.38 0 0 1-1.38 1.39h6.88a13.79 13.79 0 0 0 0-27.58Zm-15.14 27.58h2.76V.81h-1.38a1.38 1.38 0 0 0-1.38 1.38ZM146.62.81v1.38a1.38 1.38 0 0 1-1.38 1.38h-11V2.19a1.38 1.38 0 0 0-1.41-1.38Zm5.14 27.58h2.76V.81h-1.38a1.38 1.38 0 0 0-1.38 1.38ZM115.59.81h-6.89a1.38 1.38 0 0 1 1.38 1.38v1.37h5.51a11 11 0 0 1 0 22.07h-5.51V27a1.39 1.39 0 0 1-1.37 1.38h6.88a13.79 13.79 0 0 0 0-27.58Zm-14.48 24.82h-11V27a1.38 1.38 0 0 1-1.37 1.38h13.78V27a1.38 1.38 0 0 0-1.41-1.37ZM102.49.81v1.38a1.37 1.37 0 0 1-1.38 1.37h-11V2.19A1.38 1.38 0 0 0 88.7.81ZM67.36 3.57A1.38 1.38 0 0 1 66 2.19v26.2h2.75V3.57Zm8.27 13.79a1.38 1.38 0 0 1 0-2.76h-4.14a1.37 1.37 0 0 0-1 2.29l9.79 11.49h3.62l-9.39-11Zm-15.17 8.27h-4.14a11 11 0 0 1-11-11 1.38 1.38 0 0 1-2.76 0 13.79 13.79 0 0 0 13.76 13.76h5.52V27a1.38 1.38 0 0 0-1.38-1.37ZM56.32.81a1.38 1.38 0 1 1 0 2.76h4.14a1.38 1.38 0 0 0 1.38-1.38V.81Z",
    transform: "translate(-1.16 -.81)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m242.16 41.53-6.86 3.28v-2.33l4.85-2-4.85-2v-2.37l6.86 3.27H246v2.15ZM235.3 34.94v-6h1.89v3.85h2.43V29h1.89v3.78h2.58v-3.84H246v6ZM246 25.79v2.34l-10.7-4.33v-1.9l10.7-4.23V20l-2.1.78V25Zm-8.15-2.85 4.33 1.52v-3.08ZM235.3 16.59v-3.24a5.5 5.5 0 0 1 .67-3.19 3.5 3.5 0 0 1 2.91-1.36 3.42 3.42 0 0 1 2 .58 2.8 2.8 0 0 1 1.12 1.76l4-2.39V11l-5 2.87v-.42a3.4 3.4 0 0 0-.39-1.92 2 2 0 0 0-1.56-.68 1.84 1.84 0 0 0-1.55.8 2.81 2.81 0 0 0-.33 1.52v1.25H246v2.16ZM242.66 5.91c1.45-.08 1.72-1 1.72-1.51A1.45 1.45 0 0 0 243 2.94c-.91 0-1.14.77-1.74 2.26-.29.81-.95 2.67-3 2.67a3.3 3.3 0 0 1-3.17-3.54A3.15 3.15 0 0 1 238.21 1v2.07c-.49.09-1.31.28-1.31 1.33a1.25 1.25 0 0 0 1.21 1.32c.8 0 1-.56 1.75-2.37.71-1.63 1.49-2.54 3-2.54a3.2 3.2 0 0 1 3.32 3.56c0 2.43-1.46 3.69-3.53 3.67Z",
    transform: "translate(-1.16 -.81)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M206.24 14.6a11 11 0 0 1 11-11 11 11 0 0 1 11 11 1.38 1.38 0 0 1 2.76 0A13.79 13.79 0 0 0 217.27.81a13.79 13.79 0 0 0-13.79 13.79h2.76",
    transform: "translate(-1.16 -.81)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.15 20.81a11.21 11.21 0 0 0 1.85 2.06 11 11 0 0 1 7.29-2.75h.15-.13a11 11 0 0 1 7.28 2.75 11.15 11.15 0 0 0 1.82-2.06 13.71 13.71 0 0 0-9.12-3.45 13.73 13.73 0 0 0-9.14 3.45Z",
    transform: "translate(-1.16 -.81)",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.15 20.81a11 11 0 0 1-1.91-6.21h-2.76a13.73 13.73 0 0 0 2.76 8.27 14.35 14.35 0 0 1 1.91-2.06Z",
    transform: "translate(-1.16 -.81)",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.4 41.49a13.93 13.93 0 0 0 1.21-1.22 13.75 13.75 0 0 0 3.45-9.12 1.38 1.38 0 0 0-2.76 0 11 11 0 0 1-3.74 8.27 11 11 0 0 1-7.3 2.76 11 11 0 0 1-7.26-2.76 10.89 10.89 0 0 1-1.83-2.06 11.09 11.09 0 0 1-1.91-6.21 1.38 1.38 0 0 0-2.76 0 13.85 13.85 0 0 0 4.67 10.34 13.82 13.82 0 0 0 9.12 3.45 13.71 13.71 0 0 0 9.12-3.45",
    transform: "translate(-1.16 -.81)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M206.24 22.87a13.76 13.76 0 0 0-2.76 8.28 1.38 1.38 0 0 1 2.76 0 11 11 0 0 1 3.76-8.28 11.21 11.21 0 0 1-1.83-2.06 14.35 14.35 0 0 0-1.93 2.06Z",
    transform: "translate(-1.16 -.81)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.57 50.91a1.39 1.39 0 0 0 1.29.9h12.41a1.38 1.38 0 0 0 0-2.76h-13.79v1.38a1.51 1.51 0 0 0 .09.48Z",
    transform: "translate(-1.16 -.81)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.65 50.43a1.37 1.37 0 0 1-1.37 1.38h13.79v-2.76h-13.8a1.38 1.38 0 0 1 1.38 1.38Z",
    transform: "translate(-1.16 -.81)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.19 51.81h-3.33a1.36 1.36 0 0 1-.94-.38l5.09 5.1a1.39 1.39 0 0 0 2 0l1-1-3.74-3.74Z",
    transform: "translate(-1.16 -.81)",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.86 51.36Z",
    transform: "translate(-1.16 -.81)",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.4 24.94a13.92 13.92 0 0 0 1.91-2.07 13.92 13.92 0 0 1-1.91 2.07 11 11 0 0 1 1.91 6.21 11 11 0 0 0-1.91-6.21Z",
    transform: "translate(-1.16 -.81)",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.07 31.15a13.76 13.76 0 0 0-2.76-8.28 13.92 13.92 0 0 1-1.91 2.07 11 11 0 0 1 1.91 6.21 1.38 1.38 0 0 1 2.76 0Z",
    transform: "translate(-1.16 -.81)",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.07 31.15a13.76 13.76 0 0 0-2.76-8.28 13.92 13.92 0 0 1-1.91 2.07 11 11 0 0 1 1.91 6.21 1.38 1.38 0 0 1 2.76 0Z",
    transform: "translate(-1.16 -.81)",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.21 14.31a1.38 1.38 0 0 0-2.73.29h2.76ZM226.4 24.94a13.93 13.93 0 0 0 1.21-1.22l.69-.85a13.73 13.73 0 0 0 2.76-8.27 1.38 1.38 0 0 0-2.76 0 11 11 0 0 1-3.74 8.27 11 11 0 0 1-7.3 2.76 11 11 0 0 1-7.26-2.76 11.27 11.27 0 0 0-1.83 2.07 13.73 13.73 0 0 0 9.12 3.45 13.75 13.75 0 0 0 9.13-3.45",
    transform: "translate(-1.16 -.81)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.27 28.39v-2.76a11 11 0 0 1-7.27-2.76 11.27 11.27 0 0 0-1.83 2.07 13.73 13.73 0 0 0 9.12 3.45Z",
    transform: "translate(-1.16 -.81)",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredendo);
export default __webpack_public_path__ + "static/media/credendo.8641b0c28f6ddd653bf75365644a186d.svg";
export { ForwardRef as ReactComponent };